import { cartLineCardCondensedStyles as styles } from "@insite/content-library/Components/CartLineCardCondensed";
import { css } from "styled-components";

styles.price = {
    ...styles.price,
    price: {
        ...styles.price?.price,
        priceText: {
            ...styles.price?.price?.priceText,
            css: css`
                ${styles.price?.price?.priceText?.css}

                &&& {
                    font-size: 16px;
                }
            `,
        },
    },
};

styles.extendedUnitNetPrice = {
    ...styles.extendedUnitNetPrice,
    text: {
        ...styles.extendedUnitNetPrice?.text,
        size: 22,
    },
};
